import { useMemo } from 'react';

import { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Константы места загородного листингового баннера между объявлениями.
 * Должны совпадать с легаси-размещением Adfox (SuburbanListingBanner).
 */
const PLACE = 'between_offers';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'czsow', p2: 'y' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 200 };

interface IUseSuburbanListingParametersParams {
  position: number;
}

/**
 * Параметры места загородного листингового баннера (desktop).
 */
export function useSuburbanListingParameters({
  position,
}: IUseSuburbanListingParametersParams): TAdBannerPlaceParameters {
  return useMemo(
    () => ({
      place: PLACE,
      pParams: P_PARAMS,
      sizes: SIZES,
      position,
      galleryPosition: null,
      isSp: false,
      tgbNativedescGeneralDesign: null,
      carousel: null,
      deviceType: 'desktop',
    }),
    [position],
  );
}
